'use client'

// imports
import { useState, useEffect } from 'react';

// lib files
import { LIVESTREAM_PLAYER_HOST } from "@/lib/constants";
import { useIdentity } from '@/lib/hooks/useIdentity';

// components
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';

// styles
import styles from '@/components/MultiLivestream/MultiLivestream.module.scss';

type MultiLivestreamPlayerProps = {
  isSVP: boolean;
  selectedChannel: string;
  stationId: string;
  userSelectedChannel: string;
};

const MultiLivestreamPlayer = (props: MultiLivestreamPlayerProps) => {
  const { isSVP, selectedChannel, stationId, userSelectedChannel } = props;
  const [playerUrl, setPlayerUrl] = useState<string | undefined>(undefined);
  const { identity } = useIdentity();

  // Construct the player url
  let livestreamEmbedType = 'ga-livestream-portalplayer';
  const livestreamPlayerParams = new URLSearchParams();

  if(isSVP) {
    livestreamEmbedType = 'ga-livestream-stationplayer';
    livestreamPlayerParams.append('station_id', stationId);
  }

  const basePlayerUrl = `${LIVESTREAM_PLAYER_HOST}/${livestreamEmbedType}/?${livestreamPlayerParams.toString()}`;

  // when a new channel is selected, update the livestream player URL
  useEffect(() => {
    const url = new URL(basePlayerUrl);

    url.searchParams.set('feed_cid', userSelectedChannel || selectedChannel);

    if (userSelectedChannel) {
      url.searchParams.set('channel_switch', 'true');
    }

    // uid comes from the confirmed profile, not the pbs_uid cookie, so a
    // member whose cookie is unreadable still gets an authenticated livestream.
    if (identity) {
      url.searchParams.set('uid', identity.uid);
    }

    setPlayerUrl(url.toString());
  }, [basePlayerUrl, userSelectedChannel, selectedChannel, identity]);

  return (
    <section className={styles.multi_livestream__player__container}>
      {selectedChannel ? (
        <div className={styles.multi_livestream__player}>
            <iframe
              src={playerUrl}
              allow="geolocation; encrypted-media; fullscreen"
              allowFullScreen
              className={styles.livestream_player__iframe}
              name="livestream-player"
            ></iframe>
        </div>
      ) : (
        <div className={styles.multi_livestream__player__loading}>
          <LoadingSpinner
            text="Loading Live TV..."
          />
        </div>
      )}
    </section>
  );
};

export default MultiLivestreamPlayer;
